import { render, staticRenderFns } from "./FormInteresse.vue?vue&type=template&id=60993c4e&scoped=true&"
import script from "./FormInteresse.vue?vue&type=script&lang=js&"
export * from "./FormInteresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60993c4e",
  null
  
)

export default component.exports